// src/config/api.config.js

export const API_CONFIG = {
  ENDPOINTS: {
    AUTH: {
      LOGIN: "/auth/login",
      LOGOUT: "/auth/logout",
      REFRESH: "/auth/refresh",
      TELEGRAM_LOGIN: "/auth/telegram-login",
    },
    GYM: {
      CREATE: "/gym/create",
      LOGIN: "/gym/login",
      SHOW_ALL: "/gym/all",
      ME: "/gym/me",

      UPDATE: (id) => `/gym/update/${id}`,
      DELETE: (id) => `/gym/delete/${id}`,
      GETDASHBOARD: "/gym/dashboard",
      TELEGRAM_SETTINGS: "/gym/telegram-settings",
    },

    ATHLETE: {
      CREATE: "/athlete/create",
      SHOW: "/athlete/show",
      ME: "/athlete/me",
      PRINT: "/athlete/print",

      UPDATE: (id) => `/athlete/update/${id}`,
      DELETE: (id) => `/athlete/delete/${id}`,
      SEARCH_BY_ID: (id) => `/athlete/search/${id}`,
      SEARCH_BY_NAME: "/athlete/searchByName",
    },

    PROGRAM: {
      SHOW: "/program/show",
      GET_BY_ID: (id) => `/program/show/${id}`,
      CREATE: "/program/create",
      UPDATE: (id) => `/program/update/${id}`,
      DELETE: (id) => `/program/delete/${id}`,
    },

    PAYMENT: {
      PAY: "/payment/pay",
      SHOW: "/payment/show",
      DELETE: (id) => `/payment/delete/${id}`,
    },

    DAYBOOK: {
      CREATE: "/dayBook/create",
      SEARCH_PERSONS: "/dayBook/searchPersons",
      SHOW: "/dayBook/search",
      UPDATE: (id) => `/dayBook/update/${id}`,
      DELETE: (id) => `/dayBook/delete/${id}`,
    },

    TRAINER: {
      CREATE: "/trainer/create",
      SHOW: "/trainer/show",
      SEARCH_BY_ID: (id) => `/trainer/show/${id}`,
      UPDATE: (id) => `/trainer/update/${id}`,
      DELETE: (id) => `/trainer/delete/${id}`,
      SEARCH_BY_NAME: "/trainer/searchByName",
      PRINT: "/trainer/print",
    },
    DIET: {
      CREATE: "/diet/create",
      SHOW: "/diet/show",
      GET_BY_ID: (id) => `/diet/show/${id}`,
      UPDATE: (id) => `/diet/update/${id}`,
      DELETE: (id) => `/diet/delete/${id}`,
    },
    EXERCISE: {
      SHOW: "/exercises",
      CREATE: "/exercises",
      UPDATE: (id) => `/exercises/${id}`,
      DELETE: (id) => `/exercises/${id}`,
    },
    MEAL: {
      SHOW: "/meals",
      CREATE: "/meals",
      UPDATE: (id) => `/meals/${id}`,
      DELETE: (id) => `/meals/${id}`,
    },
    SETTINGS: {
      GET: "/settings",
      UPDATE: "/settings",
    },
    NOTIFICATIONS: {
      RECIPIENTS: "/notifications/recipients",
      CREATE: "/notifications/create",
      SHOW: "/notifications",
      DELETE: (id) => `/notifications/${id}`,
    },
    LOCKERS: {
      SHOW: "/lockers/show",
      CONFIG: "/lockers/config",
      ASSIGN: "/lockers/assign",
      CHECKOUT: "/lockers/checkout",
      TOGGLE_MAINTENANCE: "/lockers/toggle-maintenance",
      ITEMS: "/lockers/items",
      CLEAR_ALL: "/lockers/clear-all",
      AUTO_ASSIGN: "/lockers/auto-assign",
    },
    SYNC: "/sync",
  },
};
